(() => {
  if (window.ggBowPricingLoaded) return;
  window.ggBowPricingLoaded = true;
  const states = new Map();
  const key = root => root.dataset.productHandle || root.id;
  const state = root => { if (!states.has(key(root))) states.set(key(root),{}); return states.get(key(root)); };
  const text = (el,value) => { if(el.textContent !== value) el.textContent = value; };
  const additions = {5:0,7:7,9:9,11:11,13:13,15:15};
  const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:'USD'}).format(n);
  function update(root) {
    const box = root.querySelector('[data-gg-bow-price]');
    if (!box) return;
    const base = state(root).option === '5' ? 32.99 : state(root).option === '3' ? 27.99 : null;
    const extra = state(root).size ? additions[state(root).size] : null;
    box.hidden = false;
    root.classList.add('gg-bow-pricing-ready');
    const total = base === null ? 27.99 : base + (extra || 0);
    text(box.querySelector('[data-total]'), (base === null ? 'From ' : '') + money(total));
    text(box.querySelector('[data-breakdown]'), base === null ? 'Choose a ribbon option, then a size.' : extra === null ? 'Ribbon option: ' + money(base) + ' · Choose a size below.' : 'Ribbon option: ' + money(base) + ' + Size: ' + money(extra));
  }
  function init() {
    document.querySelectorAll('[id^="MainProduct-"]:has([data-gg-bow-price])').forEach(root => {
      if (!states.has(key(root)) && new URLSearchParams(location.search).has('variant')) {
        const option = root.querySelector('input[name="Choose Your Option"]:checked');
        const size = root.querySelector('input[name="Choose Size"]:checked');
        if(option) state(root).option = option.value[0];
        if(size) state(root).size = String(parseInt(size.value,10));
      }
      update(root);
    });
  }
  const onChoice = e => {
    const root = e.target.closest('[id^="MainProduct-"]');
    if (!root || !root.querySelector('[data-gg-bow-price]')) return;
    if (e.target.name === 'Choose Your Option') state(root).option = e.target.value[0];
    if (e.target.name === 'Choose Size') state(root).size = String(parseInt(e.target.value,10));
    update(root);
  };
  document.addEventListener('change',onChoice,true);
  document.addEventListener('click',onChoice,true);
  let scheduled=false; new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;init();});}).observe(document.documentElement,{childList:true,subtree:true});
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
